<i18n>
{
  "cl": {
    "credit": "Crédito",
    "mortgage": "Hipotecario",
    "sme": "PYME",
    "parking": " ",
    "creditComplementary": "Crédito de consumo:",
    "creditMortgage": "Crédito hipotecario",
    "origin":"origen",
    "subType":"subtipo",
    "investor":"inversionista"
  },
  "pe": {
    "credit": "Crédito",
    "mortgage": "Hipotecario",
    "sme": "PYME",
    "parking": " ",
    "creditComplementary": "Crédito de consumo:",
    "creditMortgage": "Crédito hipotecario",
    "origin":"origen",
    "subType":"subtipo",
    "investor":"inversionista"
  },
  "br": {
    "credit": "Contrato",
    "mortgage": " de Financiamento Imobiliário",
    "sme": "PYME",
    "parking": " ",
    "creditComplementary": "Crédito de consumo:",
    "creditMortgage": "Contrato de Financiamento Imobiliário:",
    "origin":"origem",
    "subType":"subtipo",
    "investor":"investor"
  }
}
</i18n>
<template>
  <div id="debt-selection-card">
    <div
      v-for="(operation, operationIndex) in operations"
      :key="`operation${operationIndex}`"
      class="credit-description">
      <div class="credit-info">
        <div class="credit-title">
          <div v-if="operation.type === 'PARKING'" class="credit-ref">
            <div>
              <span>{{ $t('credit') }}</span>
              <span v-if="operation.companyOperationId !== undefined">
                {{ operation.companyOperationId ? $t('parking') : "" }}
              </span>
            </div>
            <div>
              <span>N° {{ operationIndex + 1 }}</span>
            </div>
          </div>
          <div v-else-if="operation.type === 'SME'" class="credit-ref">
            <div>
              <span>{{ $t('credit') }}</span>
              <span v-if="operation.companyOperationId !== undefined">
                {{ operation.companyOperationId ? $t('sme') : "" }}
              </span>
            </div>
            <div>
              <span>N° {{ operationIndex + 1 }}</span>
            </div>
          </div>
          <div v-else class="credit-ref">
            <div>
              <span>{{ $t('credit') }}</span>
              <span v-if="operation.companyOperationId !== undefined && operation.type === 'PARKING'">
                {{ operation.companyOperationId ? $t('parking') : "" }}
              </span>
              <span v-if="operation.companyOperationId !== undefined && operation.type === 'MORTGAGE'">
                {{ operation.companyOperationId ? $t('mortgage') : "" }}
              </span>
              <span v-if="operation.complementaryOperation !== undefined && operation.companyOperationId !== undefined">
                {{ operation.companyOperationId && operation.complementaryOperation.companyOperationId ? "y" : "" }}
              </span>
            </div>
            <div>
              <span v-if="operation.complementaryOperation !== undefined">
                {{ operation.complementaryOperation.companyOperationId ? 'Consumo complementario' : '' }}
              </span>
              <span>N° {{ operationIndex + 1 }}</span>
            </div>
          </div>
          <div class="details-content">
            <a
              href="#"
              @click.prevent="operation._id === extendedOperationDetails ?
                extendedOperationDetails = '' :
                extendedOperationDetails = operation._id">
              <span class="fas fa-info-circle" />
            </a>
          </div>
          <div>
            <span class="alert-content-title">{{ !operation.isActive ? 'Operación desactivada' : '' }}</span>
          </div>
        </div>
        <div class="credit-details" :class="{ show: extendedOperationDetails === operation._id }">
          <span v-if="operation.companyOperationId !== undefined && operation.type === 'MORTGAGE'">
            {{ $t('creditMortgage') }} {{ operation.companyOperationId }}
          </span>
          <span v-if="operation.companyOperationId !== undefined && operation.type === 'SME'">
            {{ $t('sme') }} {{ operation.companyOperationId }}
          </span>
          <span v-if="operation.companyOperationId !== undefined && operation.type === 'PARKING'">
            {{ $t('parking') }} {{ operation.companyOperationId }}
          </span>
          <span v-if="operation.complementaryOperation !== undefined">
            {{ $t('creditComplementary') }} {{ operation.complementaryOperation.companyOperationId }}
          </span>
          <span v-if="operation.origin !== undefined && !clientId">
            {{ $t('origin') }} {{ operation.origin }}
          </span>
          <span v-if="operation.subType !== undefined && !clientId">
            {{ $t('subType') }} {{ operation.subType }}
          </span>
          <span v-if="operation.lastInvestorName !== undefined && !clientId">
            {{ $t('investor') }} {{ operation.lastInvestorName }}
          </span>
        </div>
      </div>
      <div class="fees-content">
        <related-payments
          v-for="(payments, paymentIndex) in operation.allPayments"
          :key="`payments-${paymentIndex}`"
          :payments-object="payments"
          :operation="operation"
          :payments-map="paymentsMap"
          :related-payment-id="`${operationIndex}-${paymentIndex}`"
          :payment-index="paymentIndex"
          :current-loading-payment="currentLoadingPayment"
          :current-user-is-client="!!clientId"
          :global-extended-payment="globalExtendedPayment"
          :show-remove-late-charges="showRemoveLateCharges"
          :collect-client-debt="collectClientDebt"
          :all-check-boxes-are-disabled="allCheckBoxesAreDisabled"
          class="card-item shadowless fee-light-green p-0 mt-6"
          @remove-late-charges="$emit('remove-late-charges', $event)"
          @undo-remove-late-charges="$emit('undo-remove-late-charges', $event)"
          @extend-payment="extendPayment($event || `${operationIndex}-${paymentIndex}`)"
          @change="$emit('change', $event)"
          @confirm-deselect-payment="$emit('confirm-deselect-payment', $event)" />
      </div>
    </div>
  </div>
</template>
<script>
import RelatedPayments from '@/ui/components/internal/pay-here/RelatedPayments.vue';
import { formatNumber } from '@/infrastructure/format';

export default {
  components: { RelatedPayments },
  props: [
    'operations',
    'paymentsMap',
    'currentLoadingPayment',
    'allCheckBoxesAreDisabled',
    'showRemoveLateCharges',
    'defaultExtendPaymentId',
    'collectClientDebt'
  ],
  data() {
    return {
      clientId: this.$store.state.currentUser.user.clientId,
      extendedOperationDetails: '',
      globalExtendedPayment: ''
    };
  },
  methods: {
    formatNumber: number => formatNumber({ number }),
    extendPayment(paymentId) {
      this.globalExtendedPayment = this.globalExtendedPayment !== paymentId ? paymentId : '';
    },
    showOperationDetails(operationId) {
      if (operationId === this.extendedOperationDetails) {
        this.extendedOperationDetails = '';
      } else { this.extendedOperationDetails = operationId; }
    }
  }
};
</script>
<style scoped>
.header {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}
.card-item.shadowless {
  overflow: visible;
}
.alert-content-title {
  color: var(--secondary);
  font-weight: 600;
}
.credit-info {
  display: flex;
  flex-flow: column wrap;
  gap: 0.5rem;
  margin: 20px 0px;
}
.credit-info .credit-ref {
  font-size: 18px;
  line-height: 120%;
}
.credit-title {
  display: flex;
  flex-flow: row nowrap;
  gap: 1rem;
  align-items: center;
}
.credit-ref, .credit-ref div {
  display: flex;
  align-items: center;
  flex-flow: row wrap;
  gap: 0rem 0.3rem;
}
.credit-details {
  display: flex;
  flex-flow: column;
  font-size: 13px;
  color: var(--color-moon);
  max-height: 0rem;
  overflow: hidden;
  transition: max-height 0.2s;
}
.credit-details.show {
  max-height: 5rem;
  transition: max-height 0.5s;
}
.fee-light-green {
  background: #edf9f9;
}
.fees-content {
  margin: 1.5rem 0;
  width: 100%;
}
</style>
